import React from 'react';
import IntelligenceDebugPage from '../components/LensIntelligence/IntelligenceDebugPage';

const LensIntelligenceDebugView = () => <IntelligenceDebugPage />;

export default LensIntelligenceDebugView;
